// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zTLF2LwHaBEdT5Tsriuj {
  max-width: 100px;
  max-height: 100px;
}
.SFg_lvnfg1SaiXZ7cZIg {
  width: 150px;
  height: 150px;
}
`, "",{"version":3,"sources":["webpack://./src/admin-pages/NozzleShape/index.module.less"],"names":[],"mappings":"AAIA;EACE,gBAAA;EACA,iBAAA;AAHF;AAMA;EACE,YAAA;EACA,aAAA;AAJF","sourcesContent":[".container {\n\n}\n\n.nozzleImg {\n  max-width: 100px;\n  max-height: 100px;\n}\n\n.disabledSvg {\n  width: 150px;\n  height: 150px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nozzleImg": `zTLF2LwHaBEdT5Tsriuj`,
	"disabledSvg": `SFg_lvnfg1SaiXZ7cZIg`
};
export default ___CSS_LOADER_EXPORT___;
